import MaintenanceStatusProvider from '../providers/MaintenanceStatusProvider'

var MaintenanceStatusService = function () {
  return {
    async GetMaintenanceStatus (complexid) {
      return MaintenanceStatusProvider.GetMaintenanceStatus(complexid)
    }
  }
}
export default new MaintenanceStatusService()



// WEBPACK FOOTER //
// ./src/services/MaintenanceStatusService.js